import useRestMutation from "../useRestMutation";

// `useLazyRestQuery` is currently identical in behavior to `useRestMutation`.
// The intended difference in usage is that `useLazyRestQuery` should be used
// for "queries" (data read requests), whereas `useRestMutation` should be for
// "mutations" (data write requests).
const useLazyRestQuery = useRestMutation;

export default useLazyRestQuery;
